import { getApiClient } from 'adapter/out/client/apiClient';
import ReadReportInstanceCriteria from 'use-case/reportInstance/read/readReportInstanceCriteria';
import { ReportInstance } from 'domain/entity/reportInstance';

const readReportInstanceApiClient = getApiClient(
    (criteria: ReadReportInstanceCriteria) => `dashboards/reports/${criteria.id}`,
    ReportInstance
);

export default readReportInstanceApiClient;
